export default {
    namespaced: true,
    state: {
        is_loading: false,
        application_name: '',
        app_version: g_version,
        user_info: g_user_info !== "" ? JSON.parse(g_user_info) : "",
    },
    mutations: {
        setLoading(state, obj) {
            state.is_loading = obj;
        },
    },
};
